<!--
  name : 김장호
  desc : 
  date : 2020-07-08
-->
<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <!-- If using vue-router -->
      <router-view></router-view>
    </v-container>
  </v-main>
</template>
<script>
export default {
  name: 's-content',
  components: {
  },
  filters: {
  },
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>